import React from "react";

//Upload Feedback Creator
function createUserFeedback(addedFiles, statusShare, createToast) {
    const uploadResourceUserMessages = {
        "success": {
            header: 'Data Source(s) Added',
            subHeader: `${process.env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} will use these in the generation of future responses.`,
        },
        "warning": {
            header: 'Some Files had Errors during Upload',
            subHeader: 'Review the reason for failure and retry.',
        },
        "error": {
            header: 'All Files had Errors during Upload',
            subHeader: 'Review the reason for failure and retry.',
        },
        "refresh": { // This is the default key
            header: "It's Not You, It's Me...",
            subHeader: 'Something unexpected happened during the upload.\nRefresh the page and try again! Your Chat is saved!',
        },
    };
    
    const getUploadStatus = (addedFiles) => {
        let allFail = addedFiles.every(file => !file.isSuccess);
        let anyFail = addedFiles.some(file => !file.isSuccess);
        let status;
        if (allFail) {
            status = 'error';
        } else if (anyFail) {
            status = 'warning';
        } else {
            status = 'success';
        }
        return status;
    };

    const uploadStatus = getUploadStatus(addedFiles);
    // statusShare(uploadStatus);
    const fileList = addedFiles.map((file, index) => (
        <li key={index}>
            <strong>File Name: </strong> {file.resourceName}
            {!file.isSuccess && (
                <>
                    <br />
                    <strong>Reason: </strong> {file.Message}
                </>
            )}
        </li>
    ));

    const userMessage = uploadResourceUserMessages[uploadStatus];
    const { header: head, subHeader: sub } = userMessage;
    const toastMessage = (
        <>
            <h4>{head}</h4>
            <div>{sub}</div>
            {fileList && fileList.length > 0 && <ul>{fileList}</ul>}
        </>
    );
    createToast(toastMessage, uploadStatus);
}

function rejectToast(badFiles, createToast) {

    const fileList = badFiles.map((file, index) => (
        <li key={index}>
            <strong>File Name: </strong> {file.name}
            <br />
            <strong>Reason: </strong> {file.reason}
        </li>
    ));
    const toastMessage = (
        <>
            <h4>Unsupported File Type</h4>
            <div>Sorry I can't read that, try saving it as a different extension!</div>
            {fileList.length > 0 && <ul>{fileList}</ul>}
        </>
    );
    createToast(toastMessage, 'warning');
}

function errorToast(errorFiles, createToast) {
    // Create list of files with errors
    const fileList = errorFiles.map((file, index) => (
        <li key={index}>
            <strong>File Name: </strong> {file.name}
            <br />
            <strong>Reason: </strong> {file.reason || file.message || "Unknown error"}
        </li>
    ));
    
    const toastMessage = (
        <>
            <h4>Upload Error Occurred</h4>
            <div>There was a problem processing these file(s):</div>
            {fileList.length > 0 && <ul>{fileList}</ul>}
        </>
    )
    createToast(toastMessage, 'error');
}

export { createUserFeedback, rejectToast, errorToast };